import { showResponseMessage } from "../Components/utils/handellApiResponse";
import usersServices from "../api-services/users-services";

export const createUserSlice = (set) => ({
  users: [],
  usersLoading: false,
  user: {},
  userLoading: false,
  fetchUserFunction: async (id) => {
    set((state) => ({
      ...state,
      userLoading: true,
    }));
    try {
      const response = await usersServices.getUser(id);
      set((state) => ({
        ...state,
        user: response.data.data,
        userLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        userLoading: false,
      }));
    }
  },
  fetchUsersFunction: async () => {
    set((state) => ({
      ...state,
      usersLoading: true,
    }));
    try {
      const response = await usersServices.getUsers();
      set((state) => ({
        ...state,
        users: response.data.data,
        usersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        usersLoading: false,
      }));
    }
  },
  storeUserFunction: async (payload) => {
    set((state) => ({
      ...state,
      usersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        usersServices.storeUser(payload),
        "store"
      );

      set((state) => ({
        ...state,
        users: [...state.users, response.data.data],
        usersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        usersLoading: false,
      }));
    }
  },
  updateUserFunction: async (payload) => {
    set((state) => ({
      ...state,
      usersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        usersServices.updateUser(payload),
        "update"
      );

      set((state) => ({
        ...state,
        users: state.users.map((e) => {
          if (e.id === payload.id) {
            return response.data.data;
          }
          return e;
        }),
        usersLoading: false,
      }));
    } catch (error) {
      set((state) => ({
        ...state,
        usersLoading: false,
      }));
    }
  },
  deleteUserTenantFunction: async (id) => {
    set((state) => ({
      ...state,
      usersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        usersServices.DeleteUser(id),
        "delete"
      );
      set((state) => ({
        ...state,
        users: state.users.filter((e) => e.id !== id),
        usersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        usersLoading: false,
      }));
    }
  },
  setUser: (payload) => set((state) => ({ ...state, user: payload })),
});
